import * as Api from '../../../extViewmodels';
import { ISelectBoxOption } from '../../../web/components/SelectBox';

export const getBrokerDealerOptions = (industry: Api.Industry): ISelectBoxOption<Api.BrokerDealer>[] => {
	if (industry === Api.Industry.HomeMaintenance) {
		return Api.AllHomeMaintenanceBrokerDealers.map(brokerDealer => {
			return {
				title: brokerDealer,
				value: brokerDealer,
			};
		});
	} else if (industry === Api.Industry.Financial) {
		return Api.AllFinancialBrokerDealers.map(brokerDealer => {
			return {
				title: brokerDealer,
				value: brokerDealer,
			};
		});
	}
	return null;
};
